var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CargarMapa',{attrs:{"configMapa":_vm.configMapa,"apiKey":"AIzaSyDTtdttxL1G8XGravnTXGV5lnAfoFlgjhc"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var google = ref.google;
var map = ref.map;
return _vm._l((_vm.markers),function(marker){return _c('Marcadores',{key:marker.id,attrs:{"marker":marker,"google":google,"map":map}})})}}])})}
var staticRenderFns = []

export { render, staticRenderFns }